module.exports = '1.1.4';



//////////////////
// WEBPACK FOOTER
// D:/NOWFLOATS/ana-web-chat-master-f726fd66c7ed228fb0b4a1e0e71ea760bd266a85/node_modules/sockjs-client/lib/version.js
// module id = ../../../../sockjs-client/lib/version.js
// module chunks = vendor